import axios from '@/http/axios';

export default {
  fetchList: (config: any = {}) => {
    return axios.get(`/question-groups`, config);
  },
  fetch: (oid, config: any = {}) => {
    return axios.get(`/question-groups/${oid}`, config);
  },
  previewForStandard: (oid, config: any = {}) => {
    return axios.put(`/question-groups/${oid}/preview-standard`, config);
  },
  previewForCandidateProfile: (oid, config: any = {}) => {
    return axios.put(
      `/question-groups/${oid}/preview-candidate-profile`,
      config
    );
  },
  create: (config: any = {}) => {
    return axios.post('/question-groups/', config);
  },
  update: (oid, config: any = {}) => {
    return axios.put(`/question-groups/${oid}`, config);
  },
  delete: (oid) => {
    return axios.delete(`/question-groups/${oid}`);
  },
  transfer: (oid, config: any = {}) => {
    return axios.put(`/question-groups/${oid}/transfer`, config);
  },
  sortLibrary: (oid, config: any = {}) => {
    return axios.put(`/question-groups/${oid}/sort-library`, config);
  },
  sortImpactedTargets: (oid, config: any = {}) => {
    return axios.put(`/question-groups/${oid}/sort-impacted-targets`, config);
  },
};
